const getDayDiff = (from, to, type) => {
	let result = '';

	let da1 = new Date(from.substring(0, 4), from.substring(4, 6), '01');
	let da2 = new Date(to.substring(0, 4), to.substring(4, 6), '31');
	let dif = da2 - da1;
	let cDay = 24 * 60 * 60 * 1000; // 시 * 분 * 초 * 밀리세컨
	let cMonth = cDay * 30; // 월 만듬
	let cYear = cMonth * 12; // 년 만듬

	if (type === 'Y') {
		result = parseInt(dif / cYear);
	} else if (type === 'M') {
		result = parseInt(dif / cMonth);
	} else {
		result = parseInt(dif / cDay);
	}

	return result;
};

const getGqmsToDate = (type, pDelimiter) => {
	let date = new Date();
	let month = parseInt(date.getMonth() + 1);
	let day = date.getDate();
	if (month < 10) month = '0' + month;
	if (day < 10) day = '0' + day;

	let currentDate = '';

	if (pDelimiter != undefined && pDelimiter != '') {
		if (type == 'yyyy') {
			currentDate = date.getFullYear();
		} else if (type == 'yyyymm') {
			currentDate = date.getFullYear() + pDelimiter + month;
		} else {
			currentDate = date.getFullYear() + pDelimiter + month + pDelimiter + day;
		}
	} else {
		if (type == 'yyyy') {
			currentDate = date.getFullYear();
		} else if (type == 'yyyymm') {
			currentDate = date.getFullYear() + month;
		} else {
			currentDate = date.getFullYear() + month + day;
		}
	}

	return currentDate;
};

const getGqmsAddDate = (pInterval, pAddVal, pYyyymmdd, pDelimiter) => {
	let yyyy;
	let mm;
	let dd;
	let cDate;
	let cYear, cMonth, cDay;

	if (pYyyymmdd == undefined || pYyyymmdd == '') {
		pYyyymmdd = new Date().getFullYear() + new Date().getMonth() + 1 + new Date().getDate();
	}

	pYyyymmdd = pYyyymmdd.replace(/-/gi, '').replace(/\./gi, '').replace(/\//gi, '');

	if (pDelimiter != undefined && pDelimiter != '') {
		pYyyymmdd = pYyyymmdd.replace(eval('/\\' + pDelimiter + '/g'), '');
	}

	yyyy = pYyyymmdd.substr(0, 4);
	mm = pYyyymmdd.substr(4, 2);
	dd = pYyyymmdd.substr(6, 2);

	if (pInterval == 'y') {
		yyyy = yyyy * 1 + pAddVal * 1;
	} else if (pInterval == 'm') {
		mm = mm * 1 + pAddVal * 1;
	} else if (pInterval == 'd') {
		dd = dd * 1 + pAddVal * 1;
	}

	cDate = new Date(yyyy, mm - 1, dd); // 12월, 31일을 초과하는 입력값에 대해 자동으로 계산된 날짜가 만들어짐.
	cYear = cDate.getFullYear();
	cMonth = cDate.getMonth() + 1;
	cDay = cDate.getDate();
	cMonth = cMonth < 10 ? '0' + cMonth : cMonth;
	cDay = cDay < 10 ? '0' + cDay : cDay;

	if (pDelimiter != undefined && pDelimiter != '') {
		return cYear + pDelimiter + cMonth + pDelimiter + cDay;
	} else {
		return cYear + '' + cMonth + '' + cDay;
	}
};

/** 예시 : lpad("01", 5, "0"); // 00001 */
const setLpad = (target, padLen, addStr) => {
	if (addStr.length > padLen) {
		//console.log('오류 : 채우고자 하는 문자열이 요청 길이보다 큽니다');
		return target;
	}
	target += ''; // 문자로
	addStr += ''; // 문자로
	while (target.length < padLen) target = addStr + target;
	target = target.length >= padLen ? target.substring(0, padLen) : target;
	return target;
};

const convertNvl = (str, defaultStr) => {
	if (typeof str === 'undefined' || str === null || str === '' || str === 'null' || str === undefined) str = defaultStr;
	return str;
};

//차트에서 사용하는 백그라운드 컬러
const setChartBgColor = index => {
	let list = [
		'rgba(255, 99, 132, 0.2)',
		'rgba(54, 162, 235, 0.2)',
		'rgba(255, 206, 86, 0.2)',
		'rgba(75, 192, 192, 0.2)',
		'rgba(153, 102, 255, 0.2)',
		'rgba(255, 159, 64, 0.2)',
		'rgba(29,204,97,0.2)',
		'rgba(61,188,223,0.2)',
		'rgba(77,128,116,0.2)',
		'rgba(255,162,191,0.2)',
		'rgba(231,113,92,0.2)',
		'rgba(231,113,92,0.2)',
		'rgba(11,82,170,0.2)',
		'rgba(220,154,37,0.2)',
		'rgba(11,38,163,0.2)',
		'rgba(91,189,28,0.2)'
	];

	return list[index];
};

//차트에서 사용하는 백그라운드 컬러
const setChartBdColor = index => {
	let list = [
		'rgba(54, 162, 235, 1)',
		'rgba(255, 206, 86, 1)',
		'rgba(75, 192, 192, 1)',
		'rgba(153, 102, 255, 1)',
		'rgba(255, 159, 64, 1)',
		'rgba(29,204,97,1)',
		'rgba(61,188,223,1)',
		'rgba(77,128,116,1)',
		'rgba(255,162,191,1)',
		'rgba(231,113,92,1)',
		'rgba(231,113,92,1)',
		'rgba(11,82,170,1)',
		'rgba(220,154,37,1)',
		'rgba(11,38,163,1)',
		'rgba(91,189,28,1)',
		'rgba(255,255,255,1)'
	];

	return list[index];
};

const setMixedChartBdColor = index => {
	let list = ['rgba(50, 174, 251, 0.2)', 'rgba(15,2,110, 0.2)', 'rgba(126,3,174, 1)'];

	return list[index];
};

const getCookie = key => {
	let result = null;
	let cookie = document.cookie.split(';');
	cookie.some(item => {
		// 공백을 제거
		item = item.replace(' ', '');
		let dic = item.split('=');
		if (key === dic[0]) {
			result = dic[1];
			return true; // break;
		}
	});
	return result;
};

const getHanBytes = str => {
	// feat : validation use
	if (str === null || str === undefined) return false;
	return str
		.split('')
		.map(s => s.charCodeAt(0))
		.reduce((prev, c) => prev + (c >> 11 ? 3 : c >> 7 ? 2 : 1), 0);
};
// export default getHanBytes;

function checkFileSize(file, size = 200) {
	if (file.size > size * 1024 * 1024) {
		return false;
	}
	return true;
}

function isObjEmpty(obj) {
	if (!obj) return true;
	if (obj.size > 0 || obj.fileSize > 0) {
		return false;
	}
	return true;
}

//한글자의 byte 길이 산출
function getByteLength(decimal) {
	return decimal >> 11 ? 3 : decimal >> 7 ? 2 : 1;
}

//문자열 입력 길이 제한
function getLimitedByteText(inputText, maxByte) {
	const characters = inputText.split('');
	let validText = '';
	let totalByte = 0;

	for (const character of characters) {
		const decimal = character.charCodeAt(0);
		const byte = getByteLength(decimal); // 글자 한 개가 몇 바이트 길이인지 구해주기
		// 현재까지의 바이트 길이와 더해 최대 바이트 길이를 넘지 않으면
		if (totalByte + byte <= maxByte) {
			totalByte += byte; // 바이트 길이 값을 더해 현재까지의 총 바이트 길이 값을 구함
			validText += character; // 글자를 더해 현재까지의 총 문자열 값을 구함
		} else {
			// 최대 바이트 길이를 넘으면
			break; // for 루프 종료
		}
	}
	return validText;
}

export default {
	getDayDiff,
	getGqmsToDate,
	getGqmsAddDate,
	setLpad,
	setChartBgColor,
	setChartBdColor,
	getCookie,
	checkFileSize,
	convertNvl,
	isObjEmpty,
	getHanBytes,
	setMixedChartBdColor,
	getLimitedByteText
};

export {
	getDayDiff,
	getGqmsToDate,
	getGqmsAddDate,
	setLpad,
	setChartBgColor,
	setChartBdColor,
	getCookie,
	checkFileSize,
	convertNvl,
	isObjEmpty,
	getHanBytes,
	setMixedChartBdColor,
	getLimitedByteText
};
